<template>
  <div ref="buttonSplit">
    <menu-wrapper :custom-width="customWidth">
      <template #menu-button="{ toggleMenu }">
        <div
          class="ms-button btn"
          :disabled="disabled"
          :class="[
            type,
            text ? '' : 'only-icon',
            radius ? 'btn-radius' : '',
            hasBorder ? '' : 'btn-border-none',
            disabled ? 'disabled-icon' : '',
          ]"
          @click.prevent="toggleMenu"
        >
          <div
            v-if="leftIcon"
            :class="[
              'icon24 icon left',
              leftIcon,
              disabled ? 'disabled-icon' : '',
            ]"
          />
          <div
            v-if="text"
            class="text"
            :class="[{ 'pl-0': leftIcon, 'pr-0': rightIcon }]"
          >
            {{ text }}
          </div>
        </div>
      </template>
      <template #menu-content>
        <menu-item
          v-for="(item, index) in menuItems"
          :key="index"
          :icon="item.icon"
          :seperator-bottom="item.seperatorBottom"
          @menu-item-click="clickItem(item)"
        >
          {{ item.text }}
        </menu-item>
      </template>
    </menu-wrapper>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue'
import MenuItem from '@/components/dropdown/MenuItem.vue'

export default defineComponent({
  name: 'MsMenuButton',
  components: {
    MenuWrapper,
    MenuItem,
  },
  props: {
    // Text hiển thị
    text: {
      default: null,
      type: String,
    },
    // Icon trái
    leftIcon: {
      default: null,
      type: String,
    },
    // Icon phải
    rightIcon: {
      default: 'chevron-down-white',
      type: String,
    },
    // Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
    type: {
      default: 'primary',
      type: String,
    },
    /**
     * Danh sách các item của context menu
     */
    menuItems: {
      type: Array,
      default: () => [],
    },
    /**
     * ĐVThi 18/02/2020
     * muốn đặt thêm stype cho lớp mục đích có cách để trên form tìm được đến control
     */
    classCustom: {
      default: '',
      type: String,
    },
    /**
     * NNLAM 26/02/2020
     * có cho phép tự custom vị trí dropdown menu hay không
     */
    customPositionMenu: {
      type: Boolean,
      default: false,
    },
    /**
     * NNLAM 26/02/2020
     * Set lại chiều dài menu dropdown
     */
    customWidth: {
      type: Number,
      default: 0,
    },
    /**
     * NNLAM 26/02/2020
     * khoảng cách của button so với lề trên/dưới
     */
    heightOffset: {
      type: Number,
      default: 5, // 25
    },
    /**
     * NNLAM 26/02/2021
     * khoảng cách của button so với lề trái/phải
     */
    widthOffset: {
      type: Number,
      default: 25,
    },
    /**
     * NNLAM 26/02/2021
     * Có show menu khi click vào icon right của button không, mặc định có
     */
    hasShowMenu: {
      type: Boolean,
      default: true,
    },
    /**
     * NNLAM 26/02/2021
     * Có tooltip cho btt không
     */
    tooltipText: {
      type: [String, Object],
      default: null,
    },
    // border hiển thị cho các button con
    hasBorder: {
      default: false,
      type: Boolean,
    },
    // border bên ngoài 2 button con
    hasBorderParent: {
      default: false,
      type: Boolean,
    },
  },
  setup (props, { emit }) {
    const clickItem = (item) => {
      emit('menuClick', item)
    }

    const toggleMenu = ref(false)
    // end -----------------------------------------------------------------------

    return {
      clickItem,
      toggleMenu,
    }
  },
})
</script>

<style scoped lang="scss">

@import '@/assets/scss/components/MsButton.scss';

.split-icon {
  width: 36px;
  height: 24px;
  margin: 0 !important;
  .icon {
    margin: 0;
    cursor: pointer;
  }
}

.context-item {
  height: 36px;
  padding: 2px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  .context-text {
    padding: 0 8px;
  }
  &:hover {
    cursor: pointer;
    background: $hover-bg;
    color: #14aa8a;
  }
}
.context-icon {
  margin-right: 8px;
}
.color-red {
  color: #ff0000;
}
.button-line {
  display: inline-block;
  width: 1px;
  height: 16px;
  background-color: #fff;
}
.split-button {
  background-color: $color-primary;
  &.border-split-btn {
    border: 1px solid #afafaf;
    border-radius: 3px;
  }
  button {
    &.primary-button {
      border-end-end-radius: unset;
      border-start-end-radius: unset;
    }
  }
}
</style>
